"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AddressFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _index = require("../../config/index");

var _index2 = require("../../fields/index");

var _Textfield = _interopRequireDefault(require("../../fields/Textfield/Textfield"));

var _addressConfig = require("./addressConfig");

var _types = require("../../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var HTMLInputEvent = _flowRuntime["default"].tdz(function () {
  return _types.HTMLInputEvent;
});

var AddressDefinition = _flowRuntime["default"].tdz(function () {
  return _addressConfig.AddressDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("address", _flowRuntime["default"].ref(AddressDefinition)), _flowRuntime["default"].property("addressTouched", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("blurField", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"].param("_arg1", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("changeField", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"].param("_arg1", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("submitFailed", _flowRuntime["default"]["boolean"]())));

var State = _flowRuntime["default"].type("State", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("manual", _flowRuntime["default"]["boolean"]())));

var AddressFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AddressFields, _React$Component);

  var _super = (0, _createSuper2["default"])(AddressFields);

  function AddressFields(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AddressFields);
    _this = _super.call(this, props);

    _this.onBlur = function (e) {
      e.target.value = '';
    };

    _this.onChange = function (e) {
      (0, _reduxForm.change)('form', e.target.value);
    };

    _this.toggleLookup = function (e) {
      e.preventDefault();

      _this.setState(function (prevState) {
        return {
          manual: !prevState.manual
        };
      });
    };

    _this.handlePostcodeBlur = function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          componentKey = _this$props.componentKey,
          blurField = _this$props.blurField;
      var postcodePath = "".concat(componentKey, ".").concat(_addressConfig.postcode.key);
      blurField(postcodePath, e.target.value.toUpperCase());
    };

    _this.state = {
      manual: false
    };
    return _this;
  }

  (0, _createClass2["default"])(AddressFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          componentKey = _this$props2.componentKey,
          changeField = _this$props2.changeField; // Get path of component instance (for use by PCA populate function below)

      var searchAddress = "".concat(componentKey, ".searchAddress");
      var namePath = "".concat(componentKey, ".").concat(_addressConfig.name.key);
      var line1Path = "".concat(componentKey, ".").concat(_addressConfig.line1.key);
      var line2Path = "".concat(componentKey, ".").concat(_addressConfig.line2.key);
      var line3Path = "".concat(componentKey, ".").concat(_addressConfig.line3.key);
      var townPath = "".concat(componentKey, ".").concat(_addressConfig.town.key);
      var postcodePath = "".concat(componentKey, ".").concat(_addressConfig.postcode.key);
      var countryPath = "".concat(componentKey, ".").concat(_addressConfig.country.key); // Load External PCA script

      var script = document.createElement('script');
      script.src = '//services.postcodeanywhere.co.uk/js/address-3.70.js';
      script.type = 'text/javascript';
      script.async = true;
      if (document.body) document.body.appendChild(script); // Load External PCA CSS

      var link = document.createElement('link');
      link.href = '//services.postcodeanywhere.co.uk/css/address-3.70.css';
      link.type = 'text/css';
      link.rel = 'stylesheet';
      if (document.body) document.body.appendChild(link); // Wait for script to load

      script.onload = function () {
        // Postcode Anywhere field mappings
        var addressFields = [{
          element: searchAddress,
          field: ''
        }];
        window.address = new window.pca.Address(addressFields, _index.pcaWorldOptions); // Load Postcode Anywhere control

        window.address.load();
        window.address.listen('populate', function (pcaAddress) {
          changeField(namePath, pcaAddress.Company);
          changeField(line1Path, pcaAddress.Line1);
          changeField(line2Path, pcaAddress.Line2);
          changeField(line3Path, pcaAddress.Line3);
          changeField(townPath, pcaAddress.City);
          changeField(postcodePath, pcaAddress.PostalCode);
          changeField(countryPath, pcaAddress.CountryIso2);
        });
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          address = _this$props3.address,
          addressTouched = _this$props3.addressTouched,
          componentKey = _this$props3.componentKey,
          submitFailed = _this$props3.submitFailed;
      var manual = this.state.manual;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row group"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col span_6_of_12 float-label"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        autoComplete: "nope",
        id: "".concat(componentKey, ".searchAddress"),
        type: "text",
        name: "".concat(componentKey, ".searchAddress"),
        onBlur: this.onBlur,
        onChange: this.onChange
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "".concat(componentKey, ".searchAddress")
      }, "Search for address")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col span_6_of_12".concat(manual || submitFailed ? ' hidden' : '')
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#address",
        onClick: this.toggleLookup,
        className: "address-link"
      }, manual ? "I'd rather look up the address" : "I'd rather enter the address manually"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: manual || submitFailed || addressTouched ? 'group' : 'group hidden'
      }, address.options && address.options.name && /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
        key: _addressConfig.name.key,
        textfield: _addressConfig.name,
        inheritedFieldValidation: address.inheritedFieldValidation
      }), /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
        key: _addressConfig.line1.key,
        textfield: _addressConfig.line1,
        inheritedFieldValidation: address.inheritedFieldValidation
      }), /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
        key: _addressConfig.line2.key,
        textfield: _addressConfig.line2,
        inheritedFieldValidation: address.inheritedFieldValidation
      }), /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
        key: _addressConfig.line3.key,
        textfield: _addressConfig.line3,
        inheritedFieldValidation: address.inheritedFieldValidation
      }), /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
        key: _addressConfig.town.key,
        textfield: _addressConfig.town,
        inheritedFieldValidation: address.inheritedFieldValidation
      }), /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
        key: _addressConfig.postcode.key,
        textfield: _addressConfig.postcode,
        inheritedFieldValidation: address.inheritedFieldValidation,
        onBlur: this.handlePostcodeBlur
      }), address.options && address.options.country && /*#__PURE__*/_react["default"].createElement(_index2.Select, {
        key: _addressConfig.country.key,
        select: _addressConfig.country,
        inheritedFieldValidation: address.inheritedFieldValidation
      })));
    }
  }]);
  return AddressFields;
}(_react["default"].Component);

exports.AddressFields = AddressFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    addressTouched: selector(state, "".concat(componentKey, ".line1")),
    submitFailed: state.form.form ? state.form.form.submitFailed : false
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeField: function changeField(path, addressFieldValue) {
      return dispatch((0, _reduxForm.change)('form', path, addressFieldValue));
    },
    blurField: function blurField(path, addressFieldValue) {
      return dispatch((0, _reduxForm.blur)('form', path, addressFieldValue, true));
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddressFields);

exports["default"] = _default;